import { useTranslation } from '@kostbar/i18n'
import type { OrderingWindow } from '@/api/types'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

interface Props {
  value: OrderingWindow
  onChange: (next: OrderingWindow) => void
}

export function OrderingForm({ value, onChange }: Props) {
  const { t: tRestaurants } = useTranslation('restaurants')
  const hasClose = value.closesLocal !== null

  return (
    <Card>
      <CardHeader>
        <CardTitle>{tRestaurants('scheduling.ordering.title')}</CardTitle>
        <CardDescription>
          {tRestaurants('scheduling.ordering.hint')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-2">
            <Label>{tRestaurants('scheduling.ordering.opensLabel')}</Label>
            <Input
              type="time"
              value={value.opensLocal}
              onChange={(e) =>
                onChange({ ...value, opensLocal: e.target.value })
              }
              className="w-32"
            />
          </div>
          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Switch
                checked={hasClose}
                onCheckedChange={(v) =>
                  onChange({ ...value, closesLocal: v ? '11:00' : null })
                }
              />
              {tRestaurants('scheduling.ordering.closeToggle')}
            </Label>
            {hasClose ? (
              <Input
                type="time"
                value={value.closesLocal ?? ''}
                onChange={(e) =>
                  onChange({ ...value, closesLocal: e.target.value })
                }
                className="w-32"
              />
            ) : (
              <p className="text-sm text-muted-foreground">
                {tRestaurants('scheduling.ordering.noCloseHint')}
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
